import React, { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

function PrintComponentMarksSheet() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sheets, setSheets] = useState([]);
  const [resultCard, setResultCard] = useState(null);
  const [includeTotals, setIncludeTotals] = useState(false);

  useEffect(() => {
    document.title = "Component Marks Sheets";
    const urlParams = new URLSearchParams(window.location.search);
    const printTotal = urlParams.get("PrintTotal") === "Yes";
    setIncludeTotals(printTotal);

    const data = {
      AccessKey,
      UserID,
      MemberType: MemberType || "Admin",
      ID: parseInt(urlParams.get("ID"), 10) || 0,
      Wing_Id: parseInt(urlParams.get("WingId"), 10) || 0,
      Class_Id: parseInt(urlParams.get("ClassId"), 10) || 0,
      Section_Id: parseInt(urlParams.get("SectionId"), 10) || 0,
      PrintTotal: printTotal ? "Yes" : "No",
    };

    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetComponentMarksSheets",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setSheets(response.data.Sheets || []);
          setResultCard(response.data.ResultCard || null);
        } else {
          setError(response.data.status_message || "Unable to load marks sheets.");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Network error while loading marks sheets.");
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger m-4">{error}</div>;
  }

  return (
    <Page orientation="landscape" size="a4">
      <table className="table table-sm table-bordered table-print" style={{ border: "transparent" }}>
        <thead>
          <tr>
            <th>
              <PrintHeader title="" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {sheets.length === 0 ? (
                <p className="text-muted">No component marks sheets found.</p>
              ) : (
                sheets.map((sheet, sheetIdx) =>
                  (sheet.Sections || []).map((section, secIdx) => {
                    const isLast =
                      sheetIdx === sheets.length - 1 &&
                      secIdx === (sheet.Sections || []).length - 1;
                    return (
                      <div
                        key={`${sheet.Source_Exam_ID}-${section.Section_ID}`}
                        style={{ pageBreakAfter: isLast ? "auto" : "always" }}
                      >
                        <div className="row mb-2">
                          <div className="col-md-5">
                            <h6 style={{ fontSize: "12px" }}>
                              Component Sheet: {sheet.Exam_Print_Title || sheet.Exam_Name}
                            </h6>
                            <small className="text-muted">
                              {section.Wing_Name}-{section.Class_Name}-{section.Section_Name}
                            </small>
                          </div>
                          <div className="col-md-4 text-center">
                            <h6 style={{ fontSize: "12px" }}>
                              {resultCard?.Print_Title || resultCard?.Title}
                            </h6>
                            <small>Total marks: {section.Total_Marks}</small>
                          </div>
                          <div className="col-md-3 text-end">
                            <h6 style={{ fontSize: "12px" }}>{section.Section_Teacher_Name}</h6>
                            {section.Missing_Marks_Count > 0 && (
                              <small className="text-danger">
                                {section.Missing_Marks_Count} missing
                              </small>
                            )}
                          </div>
                        </div>

                        <table className="table table-sm table-bordered table-print">
                          <thead>
                            <tr>
                              <th>Sr</th>
                              <th>Reg No</th>
                              <th>Student Name</th>
                              {(section.Subjects || []).map((sub) => (
                                <th key={sub.Subject_ID} style={{ textAlign: "center", fontSize: "11px" }}>
                                  {sub.Subject_Name}
                                  <br />
                                  <small>{sub.Total_Marks}</small>
                                </th>
                              ))}
                              {includeTotals && (
                                <>
                                  <th>Total</th>
                                  <th>%</th>
                                  <th>Gr</th>
                                </>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {(section.Students || []).map((student) => (
                              <tr
                                key={student.Registration_No + student.Student_Name}
                                className={student.Missing_Count > 0 ? "table-warning" : ""}
                              >
                                <td className="text-center">{student.Serial_No}</td>
                                <td>{student.Registration_No}</td>
                                <td>{student.Student_Name}</td>
                                {(student.Marks || []).map((mark, i) => (
                                  <td key={i} className="text-center">
                                    {mark ?? "-"}
                                  </td>
                                ))}
                                {includeTotals && (
                                  <>
                                    <td>{student.Obtained_Total ?? "-"}</td>
                                    <td>{student.Percent_Marks ?? "-"}</td>
                                    <td>{student.Grade || "-"}</td>
                                  </>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    );
                  })
                )
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </Page>
  );
}

export default PrintComponentMarksSheet;
